import { Howl } from 'howler';
import { useGameStore } from '../../store/gameStore';

const soundPaths = {
  btnClick: '/sounds/btnClick.mp3',
  iconBtnClick: '/sounds/icon-btn-click.mp3',
  switchClick: '/sounds/switchClick.mp3',
  tileClick: '/sounds/tile-click.mp3',
  found: '/sounds/foundWord.mp3',
  meow: '/sounds/Meow.mp3',
  neigh: '/sounds/horse.mp3',
};

export type SoundName = keyof typeof soundPaths;

const loadedSounds: Partial<Record<SoundName, Howl>> = {};

export const preloadSounds = () => {
  Object.entries(soundPaths).forEach(([name, url]) => {
    const key = name as SoundName;
    if (!loadedSounds[key]) {
      loadedSounds[key] = new Howl({
        src: [url],
        volume: 0.2,
        preload: true,
      });
    }
  });
};

export const playSound = (soundName: SoundName) => {
  if (!useGameStore.getState().soundEnabled) return;

  const sound = loadedSounds[soundName];
  if (sound) {
    sound.play();
  } else {
    // Lazy load if not preloaded (optional fallback)
    let temp: Howl;
    temp = new Howl({
      src: [soundPaths[soundName]],
      volume: 0.5,
      onend: () => temp.unload(),
    });
    temp.play();
  }
};
